import { InsType } from 'constants/enums/insType.enum';
import { Correction_FlightInfo, EndorseOption, MortgageInfo } from 'constants/models/endorseOption';
import InsTypeDefines from 'constants/models/insTypeDefines';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IProps, IFormValue } from './types';
import _ from 'lodash';
import { EndorseOptContent, EndorseOptContentTarget } from 'bff/models/member';
import { EndorseType } from 'constants/enums/endorseType';
import { EndorseAttachmentType } from 'constants/enums/endorseAttachmentType';
import commonService from 'utils/commonService';
import { EndorseTarget } from 'constants/enums/endorseTarget.enum';
import { Code, Inscat, MortgageBankContent, Postcode, SysOption } from 'bff/models/info';
import service from 'bff/services/memberCorrectionService';
// import moment from 'moment';
import moment from 'moment-timezone';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import memberProfileService from 'bff/services/memberProfileService';
import { CI_CV_TYPE } from '../CorrectionVehicle/types';
import PreviewTravel from 'components/Correction/PreviewTravel';
import PreviewVehicle from 'components/Correction/PreviewVehicle';
import PreviewFire from 'components/Correction/PreviewFire';
import { YesNo, YesNoType } from 'constants/enums/yesNo.enum';
import { VehicleItemType } from 'constants/enums/vehicleItemType';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import { CodeId } from 'constants/enums/codeId.enum';

const CorrectionPreview: React.FC<IProps> = (props) => {
  const routerHistory = useHistory();

  /** 批改頁表單值 */
  const [correctionFormVal, setCorrectionFormVal] = useState<IFormValue>(() => {
    return {
      INS_TYPE: '',
      PROD_TYPE: '',
      POLICY_NUMBER: '',
      APPLY_NO: '',
      COMPULSORY_NO: '',
      SDATE: '',
      EDATE: '',
      FULL_ADDRESS: '',
      CAR_LICENSE: '',
      CI_CV_TYPES: new Array(0),
      ENDORSE_OPTS: new Array(0),
      ORIGINAL_ENDORSE: {
        OPTION: new Array(0),
        FILES: new Array(0)
      }
    };
  });

  /** 郵遞區號 資料 */
  const [postCodes, setPostCodes] = useState<Postcode[]>(() => {
    return new Array(0);
  });

  /** UI Code Table 資料 */
  const [UICodes, setUICodes] = useState<Code[]>(() => {
    return new Array(0);
  });

  /**
 * @description 抵押權人資料
 */
  const [mortgageBanks, setMortgageBanks] = useState<MortgageBankContent[]>(() => {
    return new Array(0);
  })

  /** 強制、任意險選項值 */
  const [vehicleCVTypeSysOpts, setVehicleCVTypeSysOpts] = useState<SysOption[]>(() => {
    return new Array(0);
  });

  /** 險種資訊 */
  const [insCats, setInsCats] = useState<Inscat[]>(() => {
    return new Array(0);
  });

  useEffect(() => {
    const { state } = routerHistory.location;

    if (!state) {
      handleGoBack();
    }

    const { correctionFormVal }: any = state;

    if (!correctionFormVal) {
      handleGoBack();
    }

    setCorrectionFormVal(prevState => correctionFormVal);
  }, []);

  useEffect(() => {
    async function init() {
      const initSetting = await service.fetchPreviewInitSetting();
      if (initSetting) {
        setPostCodes(prevState => [...initSetting.postcodes]);
        setMortgageBanks(prevState => [...initSetting.mortgageBanks]);
        setVehicleCVTypeSysOpts(prevState => [...initSetting.vehicleCVTypeSysOpts]);
        setInsCats(prevState => [...initSetting.inscats]);
        setUICodes(prevState => [...initSetting.UICodes]);
      }
    }

    init();
  }, []);

  // useEffect(() => {
  //   console.log('correctionFormVal', correctionFormVal);
  // }, [correctionFormVal])

  /**
   * @description 處理返回上一頁
   */
  const handleGoBack = () => {
    routerHistory.goBack();
  };

  //#region 新增批改項目相關方法

  /**
 * @description 新增批改申請
 *
 */
  const handleSubmit = async () => {
    // 取得新增用 Req
    const req = await handleGetAddReq();
    if (!req) return;

    // console.log('correction req', JSON.stringify(req));

    const res = await service.AddCorrection(req);
    if (!res) return;

    // 下載批改申請書
    // handleDownload(res.URL);

    routerHistory.replace(RouterSettings.MemberCenter.PolicyInquiry);

    storageService.removeItem(storageKeys.CorrectionFormVal);

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: commonService.getCodeMsg(UICodes, CodeId.U034)
    });
  }

  /**
   * @description 取得新增批改用 Req
   */
  const handleGetAddReq = async () => {
    const memberId = storageService.getItem(storageKeys.MemberId);

    const memberProfile = await memberProfileService.fetchMemberProfile(memberId);
    if (!memberProfile) return;

    // 取得變更項目
    const updateItem = _.filter(correctionFormVal.ENDORSE_OPTS, (opt: EndorseOption) => opt.CHECKED);

    const endorses = new Array(0);
    let endorseDatas: any = new Array(0);
    const files = new Array(0);
    _.forEach(updateItem, (item: EndorseOption, index: number) => {

      // 未更新項目
      const originalItem = _.find(correctionFormVal.ORIGINAL_ENDORSE.OPTION,
        (opt: EndorseOptContent) => opt.ORDER_NO === item.ORDER_NO && opt.ENDORSE_TYPE === item.ENDORSE_TYPE && opt.DATA_TYPE === item.DATA_TYPE);

      if (!originalItem) return;

      switch (originalItem.ENDORSE_TYPE) {
        case EndorseType.FLIGHT_INFORMATION:
          endorseDatas = _.map(item.FLICHT_INFOS, (flightInfo: Correction_FlightInfo) => {
            return {
              DEPARTURE_TIME: moment(flightInfo.SEARCH_RESULT[0].DEPARTURE_TIME).format("YYYYMMDD"),
              AIRLINE_ID: flightInfo.CARRIER_ID,
              FLIGHT_NO: flightInfo.FLIGHT_NO,
              DEPARTURE_AIRPORT: flightInfo.SEARCH_RESULT[0].DEPARTURE_AIRPORT,
              ARRIVAL_TIME: moment(flightInfo.SEARCH_RESULT[0].ARRIVAL_TIME).format("YYYYMMDD"),
              ARRIVAL_AIRPORT: flightInfo.SEARCH_RESULT[0].ARRIVAL_AIRPORT
            }
          })
          break;
        case EndorseType.ADD_MORTGAGE:
          endorseDatas = _.map(item.MORGAGE_INFOS, (mortgageInfo: MortgageInfo) => {
            return {
              HDR_ID: mortgageInfo.HDR_ID,
              HBRCH: mortgageInfo.HBRCH_ID,
              OPERATOR: mortgageInfo.OPERATOR,
              POSTCODE: mortgageInfo.POSTCODE,
              CITY_ID: mortgageInfo.CITY_ID,
              AREA_ID: mortgageInfo.AREA_ID,
              ADDRESS: mortgageInfo.ADDRESS,
              DELIVER_BANK: mortgageInfo.DELIVER_BANK === YesNo.Yes || mortgageInfo.DELIVER_BANK === YesNoType.Yes
                ? YesNoType.Yes
                : YesNoType.No
            }
          })
          break;
        default:
          _.forEach(originalItem.TARGET, (target: EndorseOptContentTarget) => {
            endorses.push(handleGetEndorseVal(target, item));
          })
          break;
      }

      if (item.ATTACHMENT === EndorseAttachmentType.Required) {
        files.push({
          FILE_NAME: item.ATTACHMENT_NAME,
          FILE_BASE64: item.FILE_BASE64
        })
      }

    });

    return {
      ENDORSE: {
        INS_TYPE_ID: correctionFormVal.INS_TYPE,
        APPLY_NO: correctionFormVal.APPLY_NO,
        POLICY_NO: correctionFormVal.POLICY_NUMBER,
        COMPULSORY_NO: correctionFormVal.COMPULSORY_NO,
        SUBMITTER: memberProfile.NAME,
        CAR_LICENSE: correctionFormVal.CAR_LICENSE,
        SUBMITTER_ID: memberId,
        ENDORSE_LIST: _.filter(endorses, (endorse: any) => endorse),
        ENDORSE_DATA_LIST: endorseDatas
      },
      FILES: files
    }
  }

  /**
   * @description 取得變更項目值
   */
  const handleGetEndorseVal = (target: EndorseOptContentTarget, updateItem: EndorseOption) => {
    let val = '';
    switch (target.ENDORSE_TARGET) {
      case EndorseTarget.APPLICANT_POSTCODE:
      case EndorseTarget.POSTCODE:
        val = updateItem.POST_CODE;
        break;
      case EndorseTarget.APPLICANT_CITY_ID:
      case EndorseTarget.CITY_ID:
        val = updateItem.CITY_ID;
        break;
      case EndorseTarget.APPLICANT_AREA_ID:
      case EndorseTarget.AREA_ID:
        val = updateItem.AREA_ID;
        break;
      case EndorseTarget.APPLICANT_ADDRESS:
      case EndorseTarget.ADDRESS:
        val = updateItem.ADDRESS;
        break;
      case EndorseTarget.APPLICANT_MOBILE:
      case EndorseTarget.CONTACT_MOBILE:
      case EndorseTarget.MOBILE:
        val = updateItem.MOBILE;
        break;
      case EndorseTarget.APPLICANT_EMAIL:
        val = updateItem.EMAIL;
        break;
      case EndorseTarget.APPLICANT_MARRIAGE:
        val = updateItem.MARRIAGE;
        break;
      case EndorseTarget.APPLICANT_MARRIAGE_CODE:
        val = updateItem.MARRIAGE;
        break;
      case EndorseTarget.INSURED_NAME:
      case EndorseTarget.APPLICANT_NAME:
        val = updateItem.NAME;
        break;
      case EndorseTarget.ENGINE_ID:
        val = updateItem.ENGINE_ID;
        break;
      case EndorseTarget.VEHICLE_ID:
        val = updateItem.VEHICLE_ID;
        break;
      case EndorseTarget.CAR_LICENSE:
        val = `${updateItem.CAR_LICENSE_FRONT}-${updateItem.CAR_LICENSE_BACK}`;
        break;
      case EndorseTarget.ISSUE_DATE:
        val = `${updateItem.ISSUE_DATE_YEAR}${updateItem.ISSUE_DATE_MONTH}${updateItem.ISSUE_DATE_DATE}`;
        break;
      case EndorseTarget.ADDRESS_RD_ST_CODE:
        val = updateItem.BUILD_ADDRESS_STREET_ID;
        break;
      case EndorseTarget.ADDRESS_RD_ST:
        val = updateItem.BUILD_ADDRESS_STREET_ID_NAME;
        break;
      case EndorseTarget.ADDRESS_LN:
        val = updateItem.BUILD_ADDRESS_ROADWAY;
        break;
      case EndorseTarget.ADDRESS_ALY:
        val = updateItem.BUILD_ADDRESS_ALLEY;
        break;
      case EndorseTarget.ADDRESS_NO_1:
        val = updateItem.BUILD_ADDRESS_NUMBER;
        break;
      case EndorseTarget.ADDRESS_NO_2:
        val = updateItem.BUILD_ADDRESS_NUMBER_OF;
        break;
      case EndorseTarget.ADDRESS_F_1:
        val = updateItem.BUILD_ADDRESS_FLOOR;
        break;
      case EndorseTarget.ADDRESS_F_2:
        val = updateItem.BUILD_ADDRESS_FLOOR_OF;
        break;
      case EndorseTarget.ADDRESS_NOTE:
        val = updateItem.BUILD_ADDRESS_REMARK;
        break;
      default:
        break;
    }

    // 若是 標的物門牌整編 POSTCODE 、 CITY_ID 、 AREA_ID 重新給值
    if (updateItem.ENDORSE_TYPE === EndorseType.HOUSE_NUMBER) {
      switch (target.ENDORSE_TARGET) {
        case EndorseTarget.POSTCODE:
          val = updateItem.BUILD_ADDRESS_POST_CODE;
          break;
        case EndorseTarget.CITY_ID:
          val = updateItem.BUILD_ADDRESS_CITY_ID;
          break;
        case EndorseTarget.AREA_ID:
          val = updateItem.BUILD_ADDRESS_AREA_ID;
          break;
        default:
          break;
      }
    }

    // if (!val) return;

    return {
      ENDORSE_TYPE: updateItem.ENDORSE_TYPE,
      ENDORSE_TARGET: target.ENDORSE_TARGET,
      TYPE_NAME: updateItem.TYPE_NAME,
      TARGET_NAME: target.TARGET_NAME,
      ORG_VALUE: target.ORG_VALUE || '',
      ENDORSE_SOURCE: val || null
    }
  }

  /**
   * @description 下載申請書
  */
  const handleDownload = (url: string) => {
    let fileName = '';
    if (url.indexOf('/') !== -1) {
      const lastIndex = url.lastIndexOf('/');
      fileName = url.substring(lastIndex + 1);
    }

    try {
      commonService.downloadFile(url, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };
  //#endregion

  let previewItem;

  if (correctionFormVal && correctionFormVal.INS_TYPE) {
    switch (correctionFormVal.INS_TYPE) {
      case InsType.Travel:
        previewItem = (
          <PreviewTravel
            originalEndorse={correctionFormVal.ORIGINAL_ENDORSE}
            editedEndorseItems={correctionFormVal.ENDORSE_OPTS}
          />
        )
        break;
      case InsType.Car:
      case InsType.Moto:
        previewItem = (
          <PreviewVehicle
            originalEndorse={correctionFormVal.ORIGINAL_ENDORSE}
            editedEndorseItems={correctionFormVal.ENDORSE_OPTS}
            postCodes={postCodes}
          />
        )
        break;
      case InsType.Fire:
        previewItem = (
          <PreviewFire
            originalEndorse={correctionFormVal.ORIGINAL_ENDORSE}
            editedEndorseItems={correctionFormVal.ENDORSE_OPTS}
            postCodes={postCodes}
            mortgageBanks={mortgageBanks}
          />
        )
        break;
    }
  }

  return (
    <div className="correction-preview">
      <div className="template-container">
        <div className="template-content">
          <div className="correction-preview__title">批改申請 預覽畫面</div>
          <div className="correction-preview__content">
            <div className="correction-preview__item">
              <div className="correction-preview__item-title">險種</div>
              <div className="correction-preview__item-content">
                <div className="correction-preview__item-content-ins">
                  {
                    insCats && insCats.length > 0 && _.map(insCats, (inscat: Inscat, index: number) => {
                      return (
                        <div className="element__radio-group" key={index}>
                          <label>
                            <div className="element__radio">
                              <input
                                type="radio"
                                disabled
                                checked={correctionFormVal.INS_TYPE === inscat.INS_TYPE_ID}
                              />
                              <div className="element__radio-btn" />
                            </div>
                            <span>{inscat.INS_TYPE_NAME}</span>
                          </label>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
            <div className="correction-preview__info-container">
              <div className="correction-preview__info-content">
                {/* 險種 */}
                {
                  (correctionFormVal.INS_TYPE !== InsType.Car && correctionFormVal.INS_TYPE !== InsType.Moto) && (
                    <div className="correction-preview__item">
                      <div className="correction-preview__item-title">險種</div>
                      <div className="correction-preview__item-text">{InsTypeDefines[correctionFormVal.INS_TYPE as InsType]}</div>
                    </div>
                  )
                }
                {/* 商品種類 */}
                {
                  (correctionFormVal.INS_TYPE === InsType.Car || correctionFormVal.INS_TYPE === InsType.Moto) && (
                    <div className="correction-preview__item correction-preview__item__checkboxs">
                      {
                        vehicleCVTypeSysOpts && vehicleCVTypeSysOpts.length > 0 && _.map(vehicleCVTypeSysOpts, (sysOpt: SysOption, index: number) => {
                          return (
                            <div className="element__checkbox-group" key={index}>
                              <label>
                                <div className="element__checkbox">
                                  <input
                                    type="checkbox"
                                    disabled
                                    checked={_.findIndex(correctionFormVal.CI_CV_TYPES, (type: CI_CV_TYPE) => type.TYPE === sysOpt.PARAM_VALUE && type.CHECKED) !== -1}
                                  />
                                  <div className="element__checkbox-btn" />
                                </div>
                                <span>{sysOpt.PARAM_TEXT}</span>
                              </label>
                            </div>
                          )
                        })
                      }
                    </div>
                  )
                }
                {/* 保單號碼 */}
                <div className="correction-preview__item">
                  <div className="correction-preview__item-title">保單號碼</div>
                  <div className="correction-preview__item-text">{correctionFormVal.POLICY_NUMBER}</div>
                </div>
                {/** 保險期間 */}
                {
                  correctionFormVal.INS_TYPE === InsType.Travel && (
                    <div className="correction-preview__item">
                      <div className="correction-preview__item-title">保險期間</div>
                      <div className="correction-preview__item-text">
                        {
                          `${moment(correctionFormVal.SDATE).isValid() && moment(correctionFormVal.SDATE).format("YYYY/MM/DD-HH:mm")}-
                          ${moment(correctionFormVal.EDATE).isValid() && moment(correctionFormVal.EDATE).format("YYYY/MM/DD-HH:mm")}`
                        }
                      </div>
                    </div>
                  )
                }
                {/** 標的物地址 */}
                {
                  correctionFormVal.INS_TYPE === InsType.Fire && (
                    <div className="correction-preview__item">
                      <div className="correction-preview__item-title">標的物地址</div>
                      <div className="correction-preview__item-text">{correctionFormVal.FULL_ADDRESS}</div>
                    </div>
                  )
                }
                {/** 強制證號 */}
                {
                  (correctionFormVal.INS_TYPE === InsType.Car || correctionFormVal.INS_TYPE === InsType.Moto) && (
                    <div className="correction-preview__item">
                      <div className="correction-preview__item-title">強制證號</div>
                      <div className="correction-preview__item-text">{correctionFormVal.COMPULSORY_NO}</div>
                    </div>
                  )
                }
                {/** 車號 */}
                {
                  (correctionFormVal.INS_TYPE === InsType.Car || correctionFormVal.INS_TYPE === InsType.Moto) && (
                    <div className="correction-preview__item">
                      <div className="correction-preview__item-title">車號</div>
                      <div className="correction-preview__item-text">{correctionFormVal.CAR_LICENSE}</div>
                    </div>
                  )
                }
              </div>
            </div>
            {/* 變更項目 */}
            <div className="correction-preview__item">
              <div className="correction-preview__item-title">變更項目</div>
              <div className="correction-preview__item-content">
                {previewItem}
              </div>
            </div>
          </div>
          <div className="correction-preview__controls">
            <button type="button" className="element__button element__button--red" onClick={handleSubmit}>確認送出</button>
            <button type="button" className="element__button element__button--red-border" onClick={handleGoBack}>返回上一頁</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorrectionPreview;
